var MpPageResolucionesCores;

(function() {
    if (!document.querySelector('#vue-resoluciones-cores')) {
        return;
    }

    MpPageResolucionesCores = new Vue({
        el: '#vue-resoluciones-cores',
        mixins: [MpStaticPage, MpScrollTo],

        data: {
            highlights: [{}],
            all: [{}],
        },

        computed: {
            current: function() {
                return this.highlights[0];
            },

            detailed: function() {
                return this.highlights.slice(1, 3);
            }
        },

        methods:{

            getResolutions: function() {
                var cores = this.$refs.coresList.querySelectorAll('.js-cores');

                for (var i=0; i<cores.length; i++) {

                    this.all.splice(i, 1, {
                        highlight: cores[i].dataset.highlight != '',
                        title: cores[i].dataset.title,
                        gna: Number(cores[i].dataset.gna.replace(',', '.')),
                        goa: Number(cores[i].dataset.goa.replace(',', '.')),
                        fuel: Number(cores[i].dataset.fuel.replace(',', '.')),
                        glp: Number(cores[i].dataset.glp.replace(',', '.')),
                        gn: Number(cores[i].dataset.gn.replace(',', '.')),
                        pdf: cores[i].dataset.pdf,
                        fixtext: cores[i].querySelector('.js-fixtext').innerHTML,
                        fixpdf: cores[i].dataset.fixpdf,
                        visible: false,
                    });
                }

                this.highlights = this.all.filter(r => r.highlight);
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.getResolutions();
            },

            getVariation: function(index, product) {
                if (index > 1) {
                    return;
                }

                return 100*(this.highlights[index][product] - this.highlights[index+1][product])/this.highlights[index][product];
            },

            toggleItem: function(index) {
                console.log(this.highlights[index]);
                this.highlights[index].visible = !this.highlights[index].visible;
            }

        },

    });

})();
